<div id="prod-texts" class="relative">
    <header *ngIf="!readOnly && ((isCPP() || isFab()) || (isClient() && productionTexts)) || type === 'modal'" class="w-full flex flex-row justify-between p-6 border-b-2 border-dashed ">
        <div *ngIf="!readOnly && (isCPP() || isFab()  || (isClient() && productionTexts))" class="flex flex-row justify-start gap-2">
            <ng-container *ngIf="productionTexts;else noTextsTemplate">
                <button mat-stroked-button type="button" (click)="addField()">
                    <span class="flex gap-2 items-center">
                        <mat-icon>add</mat-icon>
                        <span>{{ 'PRODUCTION_TEXTS.ADD_FIELD' | translate }}</span>
                    </span>
                </button>
                <button mat-stroked-button type="button" (click)="addLanguage()" class="bg-tw-primary text-tw-text-light">
                    <span class="flex gap-2 items-center">
                        <mat-icon>language</mat-icon>
                        <span>{{ 'PRODUCTION_TEXTS.MANAGE_LANG' | translate }}</span>
                    </span>
                </button>
                <mat-divider *ngIf="isCPP() || isFab()" vertical></mat-divider>
                <button *ngIf="isCPP() || isFab()" type="button" mat-stroked-button (click)="openPrefilModal()" class="bg-tw-primary text-tw-text-light">
                    <span class="flex gap-2 items-center">
                        <mat-icon>notes</mat-icon>
                        <span>{{ 'PRODUCTION_TEXTS.PREFILL' | translate }}</span>
                    </span>
                </button>
                <!-- <button mat-flat-button [disabled]="countUpdated() === 0" class="bg-tw-primary text-tw-lightgrey" (click)="persist()"><mat-icon>save</mat-icon>{{"SAVE" | translate}}</button> -->
            </ng-container>
            <ng-template #noTextsTemplate>
                <button *ngIf="isCPP() || isFab()" type="button" mat-stroked-button class="align-middle" (click)="openAddTextDialog()">
                    <mat-icon>add</mat-icon><span>{{ 'PRODUCTION_TEXTS.ADD' | translate }}</span>
                </button>
            </ng-template>
        </div>
        <!-- <div>
            <button [matMenuTriggerFor]="menu" mat-flat-button type="button" class="min-w-fit" [disabled]="!productionTexts">
                <mat-icon>more_horiz</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
                <button mat-menu-item> {{ 'FEATURE_TO_COME' | translate }} </button>
            </mat-menu>
        </div> -->
        <!-- TMP UNTIL FRONT REWORK -->
        <div *ngIf="type === 'modal'" class="nav self-end">
            <div class="flex gap-2">
                <button mat-raised-button type="button" class="bg-tw-primary text-tw-text-light !px-2" [disabled]="display === 'legal'" (click)="display = 'legal'"> {{ 'PRODUCTION_TEXTS.LEGAL' | translate }} </button>
                <button mat-raised-button type="button" class="bg-tw-primary text-tw-text-light !px-2" [disabled]="display === 'marketing'" (click)="display = 'marketing'"> {{ 'PRODUCTION_TEXTS.MARKETING' | translate }} </button>
                <button mat-raised-button type="button" class="bg-tw-primary text-tw-text-light !px-2" [disabled]="display === 'tvn'" (click)="display = 'tvn'"> {{ 'PRODUCTION_TEXTS.TVN' | translate }} </button>
            </div>
        </div>
    </header>
    <div class="p-4" *ngIf="productionTexts">
        <ng-container *ngIf="display === 'legal' || display === 'marketing'">
            <!-- TEXTS BLOCKS -->
            <section *ngFor="let field of productionTexts.texts[display]">
                <div class="flex flex-row justify-between items-center h-28">
                    <!-- SECTION TITLE  -->
                    <div class="bg-tw-primary text-tw-text-light p-2.5 min-w-[33%]">
                        <!-- (dblclick)="clipboardCopy(field.label)" -->
                        <!-- <span class="w-fit" [textContent]="field.label" (input)="setLabel($event, field)" [attr.contenteditable]="!readOnly" tabindex="-1"></span> -->
                        <span class="w-fit">{{field.label}}</span>
                    </div>
                    <!-- FACING / BACK  -->
                    <div class="h-14 flex flex-row justify-around">
                        <div class="w-24 gap-2 flex flex-col items-center">
                            <span class="italic">{{ 'PRODUCTION_TEXTS.FACING' | translate }}</span>
                            <mat-checkbox [(ngModel)]="field.position.facing" [disabled]="readOnly" tabindex="-1"></mat-checkbox>
                        </div>
                        <div class="w-24 gap-2 flex flex-col items-center">
                            <span class="italic">{{ 'PRODUCTION_TEXTS.BACK' | translate }}</span>
                            <mat-checkbox [(ngModel)]="field.position.back" [disabled]="readOnly" tabindex="-1"></mat-checkbox>
                        </div>
                        <div class="flex flex-col justify-end">
                            <button type="button" *ngIf="!readOnly && isCPP() && !isDefaultField(field.label)" mat-icon-button (click)="openRemoveTextDialog(field)" class="text-tw-primary" tabindex="-1"><mat-icon>delete</mat-icon></button>
                        </div>
                    </div>
                </div>
                <div class="flex flex-col w-full gap-3">
                    <div class="flex flex-row justify-start items-start" *ngFor="let key of getKeys(field.langs); trackBy: trackByItems">
                        <span class="w-8 h-8 bg-tw-primary text-tw-text-light text-center content-center italic" [ngClass]="{ 'lang-box-highlighted': checkVersionChanged(field, key) && field.langs[key] !== '' }">{{ key | uppercase }}</span>
                        <div class="min-h-24 w-full bg-tw-lightgrey border-2 rounded-lg" [ngClass]="{ 'highlighted': checkVersionChanged(field, key) && field.langs[key] !== '' }">
                            <!-- (dblclick)="clipboardCopy(field.langs[item.key])" -->
                            
                            <quill-editor class="min-h-24 w-full"  [readOnly]="readOnly" [(ngModel)]="field.langs[key]" [theme]="'bubble'" placeholder="" [disabled]="readOnly"></quill-editor>
                            
                            <!-- <textarea matInput [disabled]="readOnly" rows="6" matInput style=" display: none;"></textarea>
                            <ckeditor #editor class="min-h-24" [(ngModel)]="field.langs[key]" (error)="onError($event)" [editor]="Editor" [config]="ckConfig" matInput [disabled]="readOnly">
                            </ckeditor> -->
                        </div>
                        <button type="button" *ngIf="isOperator()" mat-icon-button (click)="clipboardCopy(field.langs[key])" class="text-tw-primary" tabindex="-1"><mat-icon>content_copy</mat-icon></button>
                    </div>
                </div>
            </section>
        </ng-container>
        <!-- <app-nutritional-table-old *ngIf="display === 'tvn'" [tvn]="this.productionTexts.current.tvn"></app-nutritional-table-old> -->
        <app-nutritional-table *ngIf="display === 'tvn'" [(tvn)]="this.productionTexts.current.tvn" [last]="this.productionTexts.history.last?.tvn" [cached]="this.cachedCurrent?.current?.tvn" [type]="type" [readOnly]="readOnly"></app-nutritional-table>
    </div>
    <div class="absolute right-0 w-[12rem]">
        <div class="fixed w-[12rem] bottom-0 bg-white flex-col px-6 py-3 shadow-sm border-2 rounded-lg flex items-center" *ngIf="!readOnly && countUpdated() > 0">
            <button mat-flat-button type="button" [disabled]="readOnly" class="m-1 bg-tw-primary text-tw-lightgrey" (click)="persist()"> <span class="flex items-center gap-1"><mat-icon>save</mat-icon>{{"SAVE" | translate}}</span></button>
            <span class="text-tw-primary p-1 flex items-center gap-1"><mat-icon>warning</mat-icon> {{ countUpdated() }} modifications</span>
        </div>
    </div>
</div>